export default __webpack_public_path__ + "static/char-s-46-zh-Hans-0a22134820d0e814d68e7326f57f7ced.webp";